import jwtDecode from 'jwt-decode';

const isValidTokenOperator = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return false;
    const decodedToken = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    if (
        decodedToken.exp > currentTime &&
        ['operator', 'admin', 'registrator'].includes(
            localStorage.getItem('role'),
        )
    ) {
        return true;
    }
    return false;
};

export default isValidTokenOperator;
